import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Box, Typography, CircularProgress, Alert } from '@mui/material';
import { authClient } from '../lib/auth';
import { useAuthStore } from '../stores/authStore';

export function VerifyPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { setUser } = useAuthStore();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setError('Invalid verification link.');
      return;
    }

    authClient.magicLink
      .verify({ query: { token } })
      .then((result) => {
        if (result?.data?.user) {
          const u = result.data.user;
          setUser({
            id: u.id,
            email: u.email,
            ...(u.name != null ? { name: u.name } : {}),
            ...(u.image != null ? { image: u.image } : {}),
          });
          navigate('/dashboard', { replace: true });
        } else {
          setError('Verification failed. The link may have expired.');
        }
      })
      .catch(() => setError('Verification failed. Please try again.'));
  }, [searchParams, navigate, setUser]);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        gap: 2,
      }}
    >
      {error ? (
        <Alert severity="error">{error}</Alert>
      ) : (
        <>
          <CircularProgress />
          <Typography>Verifying your link...</Typography>
        </>
      )}
    </Box>
  );
}
